import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const subjectInstructionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubjectInstructions: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/subject-instruction"),
      }),
      providesTags: ["Paginated-Subject-Instructions"],
    }),
    getSubjectInstruction: builder.query<any, string>({
      query: (id) => ({ url: `/api/subject-instruction/${id}` }),
      providesTags: ["SubjectInstruction"],
    }),
    addSubjectInstruction: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/subject-instruction",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Paginated-Subject-Instructions"],
    }),
    updateSubjectInstruction: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/subject-instruction/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["SubjectInstruction", "Paginated-Subject-Instructions"],
    }),
    deleteSubjectInstruction: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/subject-instruction/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Paginated-Subject-Instructions"],
    }),
    toggleSubjectInstruction: builder.mutation<any, string>({
      query: (instructionId) => ({
        url: `/api/subject-instruction/toggle-state/${instructionId}`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["SubjectInstruction", "Paginated-Subject-Instructions"],
    }),
  }),
});

export const {
  useGetSubjectInstructionsQuery,
  useGetSubjectInstructionQuery,
  useAddSubjectInstructionMutation,
  useUpdateSubjectInstructionMutation,
  useDeleteSubjectInstructionMutation,
  useToggleSubjectInstructionMutation,
} = subjectInstructionApi;
